<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<ng-container *ngIf="!hasToPlaceIconRelative">
  <ng-container *ngTemplateOutlet="audioIconButton"></ng-container>
</ng-container>

<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings?.styles">
  <ng-container
    *ngIf="settings.general.link?.type; else ownVideo">
    <render-link
      *ngIf="settings?.general?.link?.type && typeOfVideo === 'own'"
      [lang]="lang"
      [link]="settings.general.link"
      [piece]="piece"
      (renderLinkEvent)="onRenderLinkClick($event)">
      <ng-container *ngTemplateOutlet="ownVideo"></ng-container>
    </render-link>
  </ng-container>

  <ng-container
    *ngIf="settings.general.link?.type; else externalVideo">
    <render-link
      *ngIf="settings?.general?.link?.type && (typeOfVideo === 'youtube' || typeOfVideo === 'vimeo')"
      [lang]="lang"
      [link]="settings.general.link"
      [piece]="piece"
      (renderLinkEvent)="onRenderLinkClick($event)">
      <ng-container *ngTemplateOutlet="externalVideo"></ng-container>
    </render-link>
  </ng-container>
</idt-common-styles-render>

<ng-template #ownVideo>
  <ng-container *idtLazyTemplate="emptyTemplate">
    <div *ngIf="typeOfVideo === 'own'">
      <ng-container *ngTemplateOutlet="coverText"></ng-container>
    </div>
    <ng-container *ngIf="this.settings?.general && orientation$ | async as orientation">
      <render-video
        *ngIf="typeOfVideo === 'own'"
        [title]="settings.general.title"
        [controls]="!!settings.general.showControls && shouldShowAccessibilityControls"
        [ariaLabel]="settings.general.alt"
        [loop]="settings.general.loop"
        [poster]="getPosterImageSrc(orientation)"
        [muted]="isMuted"
        [autoPlay]="!!settings.general.autoPlay"
        [clickable]="!!settings.general.clickToPlayPause"
        [source]="videoSrc$ | async"
        [ngClass]="{
          'video-icon-top-left': audioIconPosition === 'top-left',
          'video-icon-top-center': audioIconPosition === 'top-center',
          'video-icon-top-right': audioIconPosition === 'top-right',
          'video-icon-center-left': audioIconPosition === 'center-left',
          'video-icon-center-center': audioIconPosition === 'center-center',
          'video-icon-center-right': audioIconPosition === 'center-right',
          'video-icon-bottom-left': audioIconPosition === 'bottom-left',
          'video-icon-bottom-center': audioIconPosition === 'bottom-center',
          'video-icon-bottom-right': audioIconPosition === 'bottom-right',
          'video-icon-top-text': audioIconPosition === 'top-text',
          'video-icon-bottom-text': audioIconPosition === 'bottom-text'
        }">
      </render-video>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #emptyTemplate>
  <div
    *ngIf="(skeleton$ | async) as skeleton"
    [ngStyle]="{
      'width': skeleton.width,
      'height': skeleton.height
    }">&nbsp;</div>
</ng-template>

<ng-template #externalVideo>
  <div *ngIf="typeOfVideo === 'youtube' || typeOfVideo === 'vimeo'">
    <ng-container *ngTemplateOutlet="coverText"></ng-container>
    <ng-container *ngIf="orientation$ | async as orientation">
      <div *ngIf="isLoadingVideo && getPosterImageSrc(orientation) as image">
        <img
          class="iframe-video-poster"
          alt="Poster de {{ this.settings.general.typeOfVideo }}"
          [src]="image?.src">
      </div>
    </ng-container>
    <div
      *ngIf="typeOfVideo === 'youtube' || typeOfVideo === 'vimeo'"
      class="iframe-video"
      data-e2e="iframe-video"
      [class.pointer-events]="settings.general.link?.type"
      [innerHtml]="videoSrc$ | async">
    </div>
  </div>
</ng-template>

<ng-template #audioIconButton>
  <div
    *ngIf="settings.general.showMediaAudio && shouldShowAccessibilityControls"
    [ngClass]="{
      'audio-icon-top-left': audioIconPosition === 'top-left',
      'audio-icon-top-center': audioIconPosition === 'top-center',
      'audio-icon-top-right': audioIconPosition === 'top-right',
      'audio-icon-center-left': audioIconPosition === 'center-left',
      'audio-icon-center-center': audioIconPosition === 'center-center',
      'audio-icon-center-right': audioIconPosition === 'center-right',
      'audio-icon-bottom-left': audioIconPosition === 'bottom-left',
      'audio-icon-bottom-center': audioIconPosition === 'bottom-center',
      'audio-icon-bottom-right': audioIconPosition === 'bottom-right',
      'audio-icon-top-text': audioIconPosition === 'top-text',
      'audio-icon-bottom-text': audioIconPosition === 'bottom-text'
    }">
    <button
      *ngIf="settings.general.showMediaAudio && shouldShowAccessibilityControls"
      [ngClass]="isMuted ? 'muted' : 'not_muted'"
      class="audiomute-icon"
      aria-label="Audio mute"
      type="button"
      (click)="toggleAudioMute()">
      <svg
        *ngIf="isMuted"
        viewBox="0 0 41 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.291 10.8992C23.1242 10.4218 24.1629 11.0229 24.1631 11.9832V15.5828C25.7341 15.9401 26.7792 17.6208 26.7793 19.407C26.7793 21.1933 25.7341 22.8737 24.1631 23.2312V26.822C24.1629 27.7865 23.1164 28.3869 22.2832 27.9011L15.4004 23.8855C15.3369 23.9263 15.2668 23.9577 15.1904 23.9734L15.0645 23.9861H9.77344L9.64746 23.9734C9.40342 23.9235 9.21117 23.7311 9.16113 23.4871L9.14844 23.3611V15.4539C9.14844 15.1087 9.42826 14.8289 9.77344 14.8289H15.0645L15.1904 14.8416C15.2399 14.8517 15.2866 14.8693 15.3311 14.8904L15.3789 14.864L22.291 10.8992ZM16 15.948L15.6895 16.1257V22.6072L16.0039 22.7917L22.9131 26.822V11.9832L16 15.948ZM28.9775 14.4724C29.1743 14.1892 29.5632 14.1187 29.8467 14.3152C31.327 15.342 32.2733 17.2648 32.2734 19.407C32.2734 21.4982 31.3723 23.3786 29.9541 24.4226C29.6761 24.6272 29.2847 24.5678 29.0801 24.2898C28.8756 24.0118 28.935 23.6204 29.2129 23.4158C30.2661 22.6405 31.0234 21.1603 31.0234 19.407C31.0233 17.6094 30.2279 16.1009 29.1348 15.3425C28.8511 15.1458 28.7808 14.756 28.9775 14.4724ZM10.3984 22.7361H14.4395V16.0789H10.3984V22.7361ZM24.1631 21.9089C24.9038 21.5729 25.5293 20.6609 25.5293 19.407C25.5292 18.1531 24.9039 17.2407 24.1631 16.905V21.9089Z"
          fill="black"
        />
      </svg>

      <svg
        *ngIf="!isMuted"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5137 8.391C18.1803 8.00865 19.0117 8.49064 19.0117 9.25917V12.1381C20.2686 12.424 21.1045 13.7696 21.1045 15.1986C21.1042 16.6273 20.2682 17.9712 19.0117 18.2572V21.1303C19.0113 21.9017 18.1743 22.3822 17.5078 21.9935L11.999 18.7807C11.9216 18.8299 11.8309 18.8607 11.7324 18.8607H7.5L7.39941 18.851C7.17164 18.8044 7.00023 18.6022 7 18.3607V12.0355C7 11.7594 7.22386 11.5355 7.5 11.5355H11.7324C11.8088 11.5355 11.8805 11.5537 11.9453 11.5844L11.9834 11.5629L17.5137 8.391ZM12.4814 12.431L12.2324 12.5726V17.7582L12.4844 17.9057L18.0117 21.1303V9.25917L12.4814 12.431ZM22.8633 11.2504C23.001 11.0522 23.2561 10.9843 23.4697 11.0756L23.5586 11.1244L23.7754 11.2865C24.8345 12.1387 25.5 13.5918 25.5 15.1986C25.4998 16.8712 24.7789 18.3753 23.6445 19.2103C23.4223 19.3738 23.109 19.3259 22.9453 19.1039C22.782 18.8816 22.8298 18.5693 23.0518 18.4057L23.207 18.2826C23.9676 17.6365 24.4998 16.5132 24.5 15.1986C24.5 13.8505 23.9408 12.7046 23.1504 12.0668L22.9893 11.9467L22.9121 11.8803C22.7516 11.7122 22.7258 11.4489 22.8633 11.2504ZM8 17.8607H11.2324V12.5355H8V17.8607ZM19.0117 17.1996C19.6041 16.9308 20.1042 16.2013 20.1045 15.1986C20.1045 14.1953 19.6044 13.4643 19.0117 13.1957V17.1996Z"
          fill="black"
        />
        <path
          d="M23.4746 7.54004L8.5249 22.4897"
          stroke="black"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>
</ng-template>

<ng-template #coverText>
  <div
    class="wysiwyg"
    *ngIf="!!settings && !!settings.general.coverText">
    <div
      class="wysiwyg-position"
      [ngClass]="{
        'container-icon-top-text': audioIconPosition === 'top-text',
        'container-icon-bottom-text': audioIconPosition === 'bottom-text'
      }">
      <ng-container *ngIf="hasToPlaceIconRelative">
        <ng-container *ngTemplateOutlet="audioIconButton"></ng-container>
      </ng-container>
      <render-wysiwyg
        *ngIf="settings && settings.general.coverText"
        [html]="settings.general.coverText"
        [country]="country"
        [lang]="lang"
        [piece]="piece"
        [textPaddingTop]="settings.general.textPaddingTop"
        [textPaddingBottom]="settings.general.textPaddingBottom"
        [textPaddingLeft]="settings.general.textPaddingLeft"
        [textPaddingRight]="settings.general.textPaddingRight"
        data-e2e="render-cover-text">
      </render-wysiwyg>
    </div>
  </div>
</ng-template>
